import { useContext } from 'react';

import { InitContext } from '../InitProvider.context';

export const useInitContext = () => {
  const context = useContext(InitContext);

  if (!context) {
    throw new Error(
      'useInitContext должен быть использован внутри TelegramProvider',
    );
  }

  return context;
};
